// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"a65b051e","110":"6bf228e6","279":"8bd5ff1d","545":"d2009bfb","580":"b2957768","686":"d4a74676","728":"c3d97dab","801":"a65b051e"}[chunkId] + ".chunk.css";
};